/**
 * ヘッダーおよび開閉グロナビの制御
 */
import "@babel/polyfill";
import AnyStore from "./AnyStore";
import PerfectScrollbar from 'perfect-scrollbar';
import ResizeWatch from "../utils/ResizeWatch";
import ScrollWatch from "../utils/ScrollWatch";

export default class Gnav {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'Gnav';
    this.isOpen = false;
    this.isOver = false;
    this.isPlaying = false;
    this.isGnavWhite = false;
    this.preventScroll = 0;
    this.currentWinH = 0;
    this.bindClose = this.closeGnav.bind(this);

    this.elGnav = null; // モーダルのグロナビ
    this.btnClose = null; // モーダル内の閉じるボタン
    this.menulist = null; // モーダル内のメニュー
    this.btnBurger = null; // ハンバーガーボタン
    this.baseLines = null; // ハンバーガーボタンの線
    this.overLines = null; // ハンバーガーボタンのホバー
    this.ps = null; // モーダル内のスクロールバー

    let levelName = location.pathname.split('/')[1];
    if (!levelName) {
      levelName = 'home';

      if (!Useragnt.ie && !Useragnt.edge) {
        TweenMax.set(document.body, {className: '+=page-index--white'});
        this.isGnavWhite = true;

        this.resizeUpdate();
        ResizeWatch.registerObserver(this.name, this);
        ScrollWatch.registerObserver(this.name, this);
      }
    }
    this.activeClass = `is-active-${levelName}`;

    this.init();
  }

  /**
   * 初期化
   */
  init() {
    // グロナビ
    this.elGnav = document.getElementById('js-gnav');
    this.btnClose = document.getElementById('p-btn-close');

    // classとdisplay:blockを順番に設定する必要あり
    this.elGnav.className = this.elGnav.className + ' is-hide ' + this.activeClass;
    this.elGnav.style.display = 'block';

    // メニューのdom
    const other = this.elGnav.querySelector('.l-gnav__other');
    this.menulist = Array.from(this.elGnav.querySelectorAll('.l-gnav__menu li'));
    this.menulist.push(other.querySelector('.col-line'));
    this.menulist.push(other.querySelector('.col-title'));
    this.menulist.push(other.querySelector('.p-site-list'));

    // 開くボタン
    const bindHover = this.onHover.bind(this);
    this.btnBurger = document.getElementById('p-btn-burger');
    this.baseLines = this.btnBurger.querySelectorAll('.is-base');
    this.overLines = this.btnBurger.querySelectorAll('.is-over');
    this.btnBurger.addEventListener('mouseenter', bindHover);
    this.btnBurger.addEventListener('mouseleave', bindHover);
    this.btnBurger.addEventListener('click', this.openGnav.bind(this));

    // 遅らせて実行
    requestAnimationFrame(this.initScrollbar.bind(this));
  }

  /**
   * トップページ場合のみ、スクロールイベント
   */
  scrollUpdate(_scrollY) {
    if (this.currentWinH < _scrollY) {
      if (this.isGnavWhite) {
        this.isGnavWhite = false;
        TweenMax.set(document.body, {className: '-=page-index--white'});
      }
    } else {
      if (!this.isGnavWhite) {
        this.isGnavWhite = true;
        TweenMax.set(document.body, {className: '+=page-index--white'});
      }
    }
  }

  /**
   * トップページ場合のみ、リサイズイベント
   */
  resizeUpdate() {
    this.currentWinH = window.innerHeight;
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  /**
   * スクロールバー設定
   */
  initScrollbar() {
    // スクロールバー
    this.ps = new PerfectScrollbar(this.elGnav.querySelector('.l-gnav__scroller'), {
      suppressScrollX: true
    });
  }

  /**
   * グロナビを開く
   */
  openGnav(e) {
    e.preventDefault();

    if (this.isOpen) return;
    this.isOpen = true;

    // bodyにclassを追加
    TweenMax.set(document.body, {className: '+=is-open-gnav'});
    if (window.AAS) window.AAS.emit('gnav_open');

    if (Useragnt.ios) {
      // モーダルが開いたら、bodyにfixedを付与
      this.preventScroll = AnyStore.getScrollTop();
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.preventScroll}px`;
    }

    // グロナビ開くアニメーション
    TweenMax.set(this.elGnav, {className: '-=is-hide'});

    TweenMax.staggerFromTo(this.menulist, 0.4, {
      visibility: 'visible',
      opacity: 0,
      y: '30'
    }, {
      delay: 0.3,
      opacity: 1,
      y: '0',
      ease: Cubic.easeOut
    }, 0.04);

    // 閉じるボタン
    this.btnClose.addEventListener('click', this.bindClose);
  }

  /**
   * グロナビを閉じる
   */
  closeGnav(e) {
    e.preventDefault();

    TweenMax.killTweensOf(this.menulist);

    const tm = new TimelineMax({paused: true, onComplete: this.closeGnavComp.bind(this)});

    // グロナビ閉じるアニメーション
    tm.add('scene1', 0)
      .staggerTo(this.menulist, 0.4, {
        opacity: 0,
        y: '-30',
        ease: Cubic.easeOut
      }, 0.02)
      .set(this.elGnav, {className: '+=is-hide'}, 'scene1-=0.1');

    tm.play();

    // 閉じるボタン
    this.btnClose.removeEventListener('click', this.bindClose);

    if (Useragnt.ios) {
      // モーダルが開いたら、bodyにfixedを付与
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, this.preventScroll);
    }

    // bodyのclassを削除
    TweenMax.set(document.body, {className: '-=is-open-gnav'});
    if (window.AAS) window.AAS.emit('gnav_close');
  }

  /**
   * グロナビを閉じる完了
   */
  closeGnavComp() {
    this.isOpen = false;
  }

  /**
   * マウスホバーイベント
   * @param e
   */
  onHover(e) {
    if (e.type === 'mouseenter') {
      this.rollOver();
    } else if (e.type === 'mouseleave') {
      this.rollOut();
    }
  }

  // ロールオーバー
  rollOver() {
    this.isOver = true;
    if (!this.isPlaying) {
      this.startRollOver();
    }
  }

  // ロールオーバーのアニメーション
  startRollOver() {
    this.isPlaying = true;

    // 元の線が消える
    TweenMax.staggerFromTo(this.baseLines, 0.4, {
      transformOrigin: '100% 50%',
    }, {
      scaleX: 0,
      ease: Cubic.easeInOut
    }, 0);

    // ホバー線が表示
    TweenMax.staggerFromTo(this.overLines, 0.3, {
        transformOrigin: '0% 50%',
      }, {
        delay: 0.3,
        x: -3,
        scaleX: 1,
        ease: Cubic.easeOut
      }, 0,
      this.completRollOver.bind(this)
    );
  }

  // ロールオーバーのアニメーション終わり
  completRollOver() {
    this.isPlaying = false;
    if(!this.isOver) {
      this.startRollOut();
    }
  }

  // ロールアウト
  rollOut() {
    this.isOver = false;
    if (!this.isPlaying) {
      this.startRollOut();
    }
  }

  // ロールアウトのアニメーション
  startRollOut() {
    this.isPlaying = true;

    TweenMax.staggerFromTo(this.overLines, 0.2, {
        transformOrigin: '100% 50%',
      },{
        x: 0,
        scaleX: 0,
        ease: Cubic.easeIn
      }, 0
    );

    TweenMax.staggerFromTo(this.baseLines, 0.2, {
        transformOrigin: '0% 50%',
      },{
        delay: 0.3,
        scaleX: 1,
        ease: Cubic.easeOut
      }, 0,
      this.completRollOut.bind(this)
    );
  }

  // ロールアウトのアニメーション終わり
  completRollOut() {
    this.isPlaying = false;
    if(this.isOver) {
      this.startRollOver();
    }
  }
}
